import React, { useEffect, useState } from "react";
import ProductLists from "../../components/shopping/ProductLists";
import { ApiHook } from "../../hooks/apiHook";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ConfigProvider, Flex, Radio } from "antd";
import { getUserDefaultPlan } from "../../utils/defaultPlan";

const ShoppingLayout = () => {
  const { t } = useTranslation();
  const userPlans = useSelector((state) => {
    return state.dashboard?.appLayout?.userplans;
  });
  const location = useLocation();
  const userDefaultPlan = getUserDefaultPlan();

  const [defaultPlan, setDefaultPlan] = useState(userPlans?.defaultPlan);
  const [treePlan, setTreePlan] = useState(userPlans?.defaultPlan);

  useEffect(() => {
    const plan = location?.state?.plan ?? userDefaultPlan ?? userPlans?.defaultPlan;
    setDefaultPlan(plan);
    setTreePlan(plan);
  }, [userPlans?.defaultPlan, userDefaultPlan, location?.state?.plan]);

  const items = ApiHook.CallRepurchaseItems(treePlan);
  return (
    <>
      <div className="page_head_top">{t("reactivation")}</div>
      <div className="ewallet_top_btn_sec">
        <div className="row justify-content-between">
          <div className="col-12 col-md-8 col-lg-4 ms-auto text-end">
            <div className="dropdown btn-group top_right_pop_btn_position">
              {userPlans?.userExistInNewPlan && userPlans?.userExistInOldPlan && <div className="me-3 w-100">

                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: "#954cea", // 👈 your custom primary color
                      controlHeight: 40,       // 🔥 increases height of buttons, inputs, radios, etc.
                      borderRadius: 8,
                    },
                  }}
                >

                  <Flex vertical gap="middle">
                    <Radio.Group
                      onChange={(e) => { setTreePlan(e?.target?.value) }}
                      block
                      options={userPlans?.planOptions}
                      defaultValue={defaultPlan}
                      optionType="button"
                      buttonStyle="solid"
                      value={treePlan}
                    />
                  </Flex>
                </ConfigProvider>
              </div>}
              <Link to={"/repurchase-report"} className="top_righ_pop_btn">
                {t("reactivation_report")}
              </Link>
            </div>
          </div>
        </div>
      </div>
      {userPlans && <ProductLists products={items?.data} userPlans={userPlans} />}
    </>
  );
};

export default ShoppingLayout;
